import type { StylePropertiesTypes } from '@wix/document-services-types'
import {
	getStringFromConverter,
	getKeywordString,
	getKeywordsString,
	getLengthString,
	getPercentageString,
	getConverterString,
} from '../../utils/converterHelpers'

export const textDecorationLinesConverter = (textDecorationLines: StylePropertiesTypes.TextDecorationLine) => {
	if (textDecorationLines.type === 'Keywords') {
		return {
			[textDecorationLines.type]: textDecorationLines.value.map((keyword) => keyword.value).join(' '),
		}
	}
	return {
		[textDecorationLines.type]: textDecorationLines.value,
	}
}

export const textDecorationConverter = (styleProp: StylePropertiesTypes.TextDecoration) => {
	// Handle color with dynamic type
	const color = styleProp.color && getConverterString(styleProp.color.type, styleProp.color)

	const style = styleProp.style && getStringFromConverter(getKeywordString(styleProp.style))

	let line = ''
	if (styleProp.line) {
		const lineProp = styleProp.line
		if (lineProp.type === 'Keywords') {
			line = getStringFromConverter(getKeywordsString(lineProp))
		} else {
			line = getStringFromConverter(getKeywordString(lineProp))
		}
	}

	let thickness = ''
	if (styleProp.thickness) {
		const thicknessProp = styleProp.thickness
		if (thicknessProp.type === 'Length') {
			thickness = getStringFromConverter(getLengthString(thicknessProp))
		} else if (thicknessProp.type === 'Percentage') {
			thickness = getStringFromConverter(getPercentageString(thicknessProp))
		} else {
			thickness = getStringFromConverter(getKeywordString(thicknessProp))
		}
	}

	return {
		color,
		line,
		style,
		thickness,
		[styleProp.type]:
			'var(--{propName}-line) var(--{propName}-style) var(--{propName}-color) var(--{propName}-thickness)',
	}
}

export const textDecorationConverterMap = {
	TextDecoration: textDecorationConverter,
	TextDecorationLine: textDecorationLinesConverter,
}
